import { useCallback } from "react";
import ConversationService, {
  ICustomerConversationPayload,
} from "../services/conversation/conversation.service";

const useSyncConversationCustomer = () => {
  const syncConversationCustomer = useCallback(
    async (payload: ICustomerConversationPayload) => {
      const customerId = Number(payload?.customer_id);
      const conversationId = String(payload?.conversation_id || "").trim();

      if (!Number.isFinite(customerId) || customerId <= 0 || !conversationId) {
        return;
      }

      await ConversationService.syncCustomerConversation({
        customer_id: customerId,
        conversation_id: conversationId,
        ...(payload.chat_id && { chat_id: payload.chat_id }),
      });
    },
    [],
  );

  return {
    syncConversationCustomer,
  };
};

export default useSyncConversationCustomer;
